import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Typography, useMediaQuery, useTheme } from '@mui/material';
import ProfileIcon, {
  NewSelectedProfileIcon,
} from 'components/Icons/ProfileIcon';
import { MyContext } from 'Context';
import { getLocalStorageItem } from 'hooks';
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';

const index = ({ username, dependents, imageLink, isProfileImage }: any) => {
  const { isDependent, setIsDependent, dependentData, setDependentData } =
    useContext(MyContext);
  const [selectuser, setSelectedUser] = useState<any>(username);
  const [showdependents, setShowDependents] = useState<boolean>(false);
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const theme: any = useTheme();
  const underSm = useMediaQuery(theme.breakpoints.down('md'));

  const handleShowDependents = () => {
    setShowDependents(true);
  };

  const handleShowMenu = () => {
    setShowMenu(true);
  };

  const handleSelectUser = (kid: any) => {
    localStorage.setItem('selectedDependent', JSON.stringify(kid));
    setSelectedUser(`${kid?.firstName} ${kid?.lastName}`);
    setShowDependents(true);
    setShowMenu(true);
    setIsDependent(true);
    setDependentData({ ...kid });
  };

  const handleMyAccount = () => {
    setSelectedUser(username);
    localStorage.removeItem('selectedDependent');
    setShowDependents(false);
    setShowMenu(false);
    setIsDependent(false);
    setDependentData(false);
  };

  const image = getLocalStorageItem('profileImage');
  const {
    picture,
    account: { logo },
  } = getLocalStorageItem('roles');

  const handleCheckDependentSelected = () => {
    if (username !== selectuser) {
      return true;
    }
    return false;
  };

  if (underSm)
    return (
      <div className="m-2 flex flex-col rounded-md  bg-primary-100 ">
        {dependents.length === 0 ? (
          <Link
            to="/account"
            style={{ textDecoration: 'none', color: 'black' }}
          >
            <div
              className="flex items-center gap-2 rounded-md p-2 "
              onClick={handleShowMenu}
            >
              {isProfileImage ? (
                <div className="h-8 w-8 overflow-hidden rounded-[100%] border-[2px] border-solid border-primary-400">
                  <img
                    src={imageLink}
                    alt="user-profile"
                    className="h-full w-full rounded-full"
                  />
                </div>
              ) : (
                <NewSelectedProfileIcon />
              )}
              <div className="capitalize">{selectuser}</div>
            </div>
          </Link>
        ) : (
          !showMenu && (
            <div
              className="flex items-center justify-between rounded-md p-2 hover:bg-slate-100/30"
              onClick={handleShowMenu}
            >
              <div className="flex items-center justify-center gap-2">
                {image || picture !== null ? (
                  <img
                    src={image || picture}
                    alt="user-profile"
                    className="h-6 w-6 rounded-full object-cover"
                  />
                ) : (
                  <div className="flex h-10 w-10 items-center justify-center">
                    <ProfileIcon />
                  </div>
                )}
                <div>{selectuser === username ? 'My Account' : selectuser}</div>
              </div>
              {showMenu ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon className="" />
              )}
            </div>
          )
        )}

        {showMenu && dependents.length !== 0 && (
          <div className="cursor-pointer border-2 border-red-400 px-2">
            <Typography
              onClick={handleMyAccount}
              className="p-2 "
              fontSize={18}
            >
              My Account
            </Typography>
            <div
              // variant="text"
              onClick={handleShowDependents}
              className={`flex items-center justify-between gap-2 rounded-md p-2 text-md ${
                showdependents ? 'bg-primary-300 font-medium' : ''
              }`}
            >
              <div>Dependent</div>

              {showdependents ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon className="" />
              )}
            </div>

            {showdependents && (
              <div className="h-24 overflow-auto pb-4 ">
                {dependents?.map((kid: any) => {
                  return (
                    <div
                      className={`py-2 pl-4  ${
                        selectuser === `${kid?.firstName} ${kid?.lastName}`
                          ? 'bg-slate-100/30'
                          : ''
                      }`}
                      onClick={() => handleSelectUser(kid)}
                    >
                      {`${kid?.firstName} ${kid?.lastName}`}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}
      </div>
    );

  return (
    <div className="flex flex-col items-center justify-center font-semibold text-white">
      {dependents.length === 0 ? (
        <div
          className="flex w-full items-center justify-between text-ellipsis rounded-md p-2 text-sm"
          onClick={handleShowMenu}
        >
          <div>{selectuser}</div>
        </div>
      ) : (
        !showMenu && (
          <div
            className="flex items-center justify-between rounded-md p-2 hover:bg-slate-100/30"
            onClick={handleShowMenu}
          >
            <div>{selectuser === username ? 'My Account' : selectuser}</div>
            {showMenu ? (
              <KeyboardArrowUpIcon />
            ) : (
              <KeyboardArrowDownIcon className="" />
            )}
          </div>
        )
      )}

      {showMenu && dependents.length !== 0 && (
        <div className="cursor-pointer border-2 border-red-400 px-2">
          <div onClick={handleMyAccount} className="p-2 text-left">
            My Account
          </div>
          <div
            // variant="text"
            onClick={handleShowDependents}
            className={`flex items-center justify-between gap-2 rounded-md  p-2 text-md ${
              showdependents && username === selectuser ? 'bg-slate-100/30' : ''
            }`}
          >
            <div>Dependent</div>

            {showdependents ? (
              <KeyboardArrowUpIcon />
            ) : (
              <KeyboardArrowDownIcon className="" />
            )}
          </div>

          {showdependents && (
            <div className="h-24 overflow-auto  ">
              {dependents?.map((kid: any) => {
                return (
                  <div
                    className={`text-ellipsis rounded-md py-2 pl-4  shadow-md ${
                      selectuser === `${kid?.firstName} ${kid?.lastName}`
                        ? 'bg-slate-100/30'
                        : ''
                    }`}
                    onClick={() => handleSelectUser(kid)}
                  >
                    {`${kid?.firstName} ${kid?.lastName}`}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default index;
